export default "__VITE_ASSET__CMdU4wnu__"